/**
 * Tamil → English place helpers for voice booking.
 * Used when Web Speech returns Tamil-script text; output feeds Google Places.
 */

const TAMIL_PLACE_MAP = {
  கோயம்புத்தூர்: 'Coimbatore',
  கோவை: 'Coimbatore',
  திருப்பூர்: 'Tiruppur',
  பொள்ளாச்சி: 'Pollachi',
  சென்னை: 'Chennai',
  மதுரை: 'Madurai',
  திருச்சி: 'Trichy',
  திருச்சிராப்பள்ளி: 'Tiruchirappalli',
  சேலம்: 'Salem',
  ஈரோடு: 'Erode',
  உதகை: 'Ooty',
  ஊட்டி: 'Ooty',
  பெங்களூர்: 'Bangalore',
  பெங்களூரு: 'Bangalore',
  நஞ்சப்பா: 'Nanjappa',
  நஞ்சப்பாநகர்: 'Nanjappa Nagar',
  'நஞ்சப்பா நகர்': 'Nanjappa Nagar',
  விருத்தாசலம்: 'Virudhachalam',
  விருதுநகர்: 'Virudhunagar',
  தஞ்சாவூர்: 'Thanjavur',
  காஞ்சிபுரம்: 'Kanchipuram',
  வேலூர்: 'Vellore',
  தூத்துக்குடி: 'Tuticorin',
  நாகர்கோயில்: 'Nagercoil',
  கன்னியாகுமரி: 'Kanyakumari',
  ராமேஸ்வரம்: 'Rameswaram',
  கோவைவிமானநிலையம்: 'Coimbatore Airport',
  'கோவை விமான நிலையம்': 'Coimbatore Airport',
  'சென்னை விமான நிலையம்': 'Chennai Airport',
};

const isTamilScript = (text) => /[\u0B80-\u0BFF]/.test(text || '');

/**
 * Replace known Tamil place tokens with English names, longest match first.
 * Preserves residual English/punctuation so locality + city can both survive.
 */
const resolveTamilLocationQuery = (raw) => {
  const text = String(raw || '').trim();
  if (!text) return '';
  if (!isTamilScript(text)) return text;

  const entries = Object.entries(TAMIL_PLACE_MAP).sort((a, b) => b[0].length - a[0].length);
  let resolved = text;
  entries.forEach(([ta, en]) => {
    if (resolved.includes(ta)) {
      resolved = resolved.split(ta).join(en);
    }
  });

  resolved = resolved
    .replace(/[\u0B80-\u0BFF]+/g, ' ')
    .replace(/\s+/g, ' ')
    .replace(/\s*,\s*/g, ', ')
    .trim()
    .replace(/^,|,$/g, '')
    .trim();

  return resolved || text;
};

module.exports = {
  TAMIL_PLACE_MAP,
  isTamilScript,
  resolveTamilLocationQuery,
};
